import type { MaybeRefOrGetter } from 'vue'
import { ref, toValue, watch } from 'vue'
import useApi from '../../components/js/Composables/useApi'
import type { AcceptedDemandsSummary } from '../../Types/demand'

const emptySummary = (): AcceptedDemandsSummary => ({ number: 0, amount: 0 })

export function useSimulationAcceptedDemands(simulationId: MaybeRefOrGetter<number | null>) {
  const { getJSON } = useApi()

  const data = ref<AcceptedDemandsSummary>(emptySummary())
  const loading = ref(false)

  async function refresh(): Promise<void> {
    const id = toValue(simulationId)

    if (!id) {
      data.value = emptySummary()
      return
    }

    loading.value = true
    try {
      data.value = await getJSON(`quotations/${id}/accepted-demands/summary`)
    } catch (reason) {
      console.error(reason)
    } finally {
      loading.value = false
    }
  }

  watch(() => toValue(simulationId), refresh)

  return {
    data,
    loading,
    refresh,
  }
}
